import { Component } from '@angular/core';

interface NoHassle {
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-no-hassle',
  templateUrl: './no-hassle.component.html',
  styleUrls: ['./no-hassle.component.scss',],
})
export class NoHassleComponent {

  noHassles: NoHassle[] = [
    {
      icon: 'assets/illustrations/no-hassle/freepickup.svg',
      title: 'Free Pickup & Drop',
      description: 'We know how valuable your time is, hence free pickup & drop is part of PPP Subscription',
    },
    {
      icon: 'assets/illustrations/no-hassle/warranty.svg',
      title: 'End to end Warranty',
      description: 'We help you save heavy one-time money commitments on your car purchase.',
    },
    {
      icon: 'assets/illustrations/no-hassle/downpayment.svg',
      title: 'Zero Down Payment',
      description: 'We help you save heavy one-time money commitments on your car purchase.',
    },
    {
      icon: 'assets/illustrations/no-hassle/insurance.svg',
      title: 'Insurance Coverage',
      description: 'We\'ve got you covered. Just care about your car as much as we do.',
    },
    {
      icon: 'assets/illustrations/no-hassle/service.svg',
      title: 'Regular Maintenance',
      description: 'We really love our cars. All regular wear and tear expenses are on us.',
    },
    {
      icon: 'assets/illustrations/no-hassle/pride.svg',
      title: 'Pride of Ownership',
      description: 'Our cars comes with a White Number Plate (private registeration)',
    },

  ];

  constructor() { }

}
